import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const fetchCustomerInfo = createAsyncThunk('users/fetchCustomerInfo', async (customerId, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/users/${customerId}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const fetchAllUsers = createAsyncThunk('users/fetchAllUsers', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/users?limit=10&page=${page}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeUserStatus = createAsyncThunk(
  'users/changeUserStatus',
  async ({ customerId, payload }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`/users/${customerId}`, { ...payload });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// GET USER STATS
export const getUserStats = createAsyncThunk('users/getUserStats', async (__, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard/reports/user-stats`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getAdminProfile = createAsyncThunk('users/getAdminProfile', async (_, thunkAPI) => {
  try {
    const getProfile = await axiosInstance.get(`/profile`);
    const response = await axiosInstance.get(`/users/${getProfile.data.id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const fetchAllUsersInfluencer = createAsyncThunk('users/fetchAllUsersInfluencer', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/influencers?limit=10&page=${page}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const fetchInfluencerInfo = createAsyncThunk('users/fetchInfluencerInfo', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/influencers/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteUserById = createAsyncThunk('users/deleteUserById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/admin/influencers/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const fetchInfluencerReferralHistory = createAsyncThunk(
  'users/fetchInfluencerReferralHistory',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/admin/referrer-history?referrer_id=${id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const createUserInfluencer = createAsyncThunk('users/createUserInfluencer', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/admin/influencers`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const editUserInfluencer = createAsyncThunk('users/editUserInfluencer', async (payload, thunkAPI) => {
  const { id, data } = payload;

  try {
    const response = await axiosInstance.put(`/admin/influencers/${id}`, { ...data });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const generateReferralCode = createAsyncThunk('users/generateReferralCode', async (name, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/generate-referral-code?name=${name}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
